import { useOktaAuth } from "@okta/okta-react";

const CheckLogin: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  if (!authState) {
   
    return <div>Error: Unable to determine authentication state.</div>;
  }

  if (authState.isPending) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect();
    return null; // Render nothing while redirecting
  }
  return children;
};

export default CheckLogin